import './Footer.css'


const Footer = () => {
    return(
        <div className='Footer'>
            <div className='Footer-Wrapper'>
                <div>
                <img src='https://resources.groww.in/web-assets/img/website-logo/groww-logo-light.svg'/>
                </div>
                <div>
                    PRODUCTS
                </div>
                <div>
                    GROWW
                </div>
                <div>
                    QUICK LINKS
                </div>
            </div>
         </div>
    )
}


export default Footer